import React, { Component } from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import { A, CrossIcon, TickModalIcon, AlertIcon, Interactive } from "AtomicComponents"
import { BASE_COPY } from "constants/general-style"
import COLOR_PALETTE from "constants/color-palette"

class FlashMessage extends Component {
  constructor() {
    super()
    // State is used here to avoid using animation keyframes which is buggy for Safari IOS & IE
    this.state = { open: false }
  }
  componentDidMount() {
    this.setState({ open: true })
  }
  render() {
    const {
      message,
      type = "MESSAGE",
      onDismiss,
      index = 0,
      style = {}
    } = this.props
    const typeStyle = typeStyles[type] || typeStyles.MESSAGE
    return (
      <div style={{ overflow: "hidden" }}>
        <div style={[
          styles.slideIn(this.state.open, index),
          styles.base,
          { padding: onDismiss ? "1em 6em 1em 1em" : "1em" },
          style
        ]}>
          <span style={styles.message}>
            <div style={{
              display: "flex"
            }}>
              {typeStyle.icon && typeStyle.icon()}
            </div>
            {message}
          </span>
          {onDismiss &&
            <div style={styles.dismiss}>
              <A withoutStyle  onClick={onDismiss}>
                <Interactive>
                  <CrossIcon style={{
                    fill: "currentColor",
                    height: "13px",
                    width: "13px",
                    margin: "0 8px -2px 0"
                  }} />
                  Dismiss
                </Interactive>
              </A>
            </div>
          }
        </div>
      </div>
    )
  }
}

const styles = {
  base: {
    ...BASE_COPY,
    position: "relative",
    backgroundColor: COLOR_PALETTE.GRAY_LIGHTER,
    display: "block",
    textAlign: "center",
    "@media (min-width: 768px)": {
      padding: "1em 6em"
    }
  },
  slideIn: (open, index) => ({
    opacity: open ? 1 : 0,
    transform: open ? "translateY(0)" : "translateY(-100%)",
    transition: `.666s ${0.2 * index}s`
  }),
  dismiss: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    padding: "1em",
    display: "flex"
  },
  link: {
    cursor: "pointer",
    fontWeight: 400,
    color: COLOR_PALETTE.GRAY_DARK,
    fontSize: "90%",
    display: "flex",
    alignItems: "center",
    transition: "color 0.25s",
    ":hover": {
      color: COLOR_PALETTE.GRAY_DARKER
    }
  },
  message: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  statusIconSvg: {
    height: "1.2em",
    width: "1.2em",
    marginRight: "0.6em"
  }
}

const typeStyles = {
  MESSAGE: {
  },
  SUCCESS: {
    icon: () => (
      <TickModalIcon style={styles.statusIconSvg} />
    )
  },
  ERROR: {
    icon: () => (
      <AlertIcon style={styles.statusIconSvg} />
    )
  }
}

FlashMessage.propTypes = {
  type: PropTypes.oneOf(["SUCCESS", "ERROR", "MESSAGE"]),
  message: PropTypes.string,
  onDismiss: PropTypes.func,
  index: PropTypes.number,
  style: PropTypes.object
}

export default Radium(FlashMessage)



// WEBPACK FOOTER //
// ./src/components/flash-message/index.jsx